import { gql } from "@apollo/client";

export const spotlightStoriesQuery = gql`
    query spotlightStories {
        spotlightStories(input: { assetType: LENS_CREATOR, sortBy: VIEWS }) {
            stories {
                storySnapId
                unlockableId
                views
                mediaUrl
            }
        }
    }
`;
